export interface Category {
  key: string;
  link: string;
  image: string;
}

export const categories: Category[] = [
  {
    key: 'shoes',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Single%20white%20leather%20sneaker%20product%20photography%20on%20clean%20soft%20cream%20studio%20background%20with%20gentle%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20neutral%20backdrop&width=480&height=480&seq=cat-shoes-01&orientation=squarish',
  },
  {
    key: 'hoodies',
    link: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Neatly%20folded%20sage%20green%20hoodie%20sweater%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20backdrop&width=480&height=480&seq=cat-hoodies-02&orientation=squarish',
  },
  {
    key: 'tshirts',
    link: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Plain%20white%20cotton%20t-shirt%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20neutral%20backdrop&width=480&height=480&seq=cat-tshirts-03&orientation=squarish',
  },
  {
    key: 'jackets',
    link: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Classic%20blue%20denim%20jacket%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20backdrop&width=480&height=480&seq=cat-jackets-04&orientation=squarish',
  },
  {
    key: 'pants',
    link: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Neatly%20folded%20beige%20cargo%20pants%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20backdrop&width=480&height=480&seq=cat-pants-05&orientation=squarish',
  },
  {
    key: 'headwear',
    link: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Black%20baseball%20cap%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20backdrop&width=480&height=480&seq=cat-headwear-06&orientation=squarish',
  },
  {
    key: 'sets',
    link: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Matching%20two%20piece%20tracksuit%20set%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20backdrop&width=480&height=480&seq=cat-sets-07&orientation=squarish',
  },
  {
    key: 'underwear',
    link: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Neatly%20folded%20grey%20underwear%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20backdrop&width=480&height=480&seq=cat-underwear-08&orientation=squarish',
  },
  {
    key: 'jersey',
    link: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Football%20soccer%20jersey%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20backdrop&width=480&height=480&seq=cat-jersey-09&orientation=squarish',
  },
  {
    key: 'accessories',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Wristwatch%20and%20sunglasses%20accessories%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20backdrop&width=480&height=480&seq=cat-accessories-10&orientation=squarish',
  },
  {
    key: 'bags',
    link: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Tan%20leather%20handbag%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20backdrop&width=480&height=480&seq=cat-bags-11&orientation=squarish',
  },
  {
    key: 'belts',
    link: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Coiled%20brown%20leather%20belt%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20backdrop&width=480&height=480&seq=cat-belts-12&orientation=squarish',
  },
  {
    key: 'perfumes',
    link: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Glass%20perfume%20bottle%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail%20simple%20backdrop&width=480&height=480&seq=cat-perfumes-13&orientation=squarish',
  },
  {
    key: 'other',
    link: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Assorted%20fashion%20accessories%20flat%20lay%20with%20hat%20scarf%20and%20glasses%20on%20clean%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail&width=480&height=480&seq=cat-other-14&orientation=squarish',
  },
];

export const mainWebsiteUrl = 'https://kaspreadsheet.com';